<template>
    <div class="mt-5" v-on:keyup.enter="tempReservation?confirm:true">
        <v-row v-if="!tempReservation">
            <v-col offset-md="3" cols="12" md="6" v-if="notFoundMessage!==''">
                <h5 class="red--text">{{notFoundMessage}}</h5>
            </v-col>
            <form v-on:keydown.enter="searchCustomer" style="width: 100%">
                <v-col offset-md="3" cols="12" md="6">
                    <v-text-field label="Full Name" v-model="model.full_name"></v-text-field>
                    <v-text-field label="Date Of Birth (mm/dd/yyyy)" v-model="model.dob" v-mask="'##/##/####'" placeholder="mm/dd/yyyy"></v-text-field>
                </v-col>
                <v-col offset-md="3" cols="12" md="6" >
                    <v-btn @click="skip">Skip</v-btn>
                    <v-btn class="ml-2" color="primary"  @click="searchCustomer">Search</v-btn>
                </v-col>
            </form>
        </v-row>
        <v-row v-if="tempReservation">
            <form v-on:keydown.enter="confirm" style="width: 100%">
                <v-col offset-md="3" cols="12" md="6">
                    <h4 class="blue--text mb-5">We found you in the system! Please confirm.</h4>
                    <div>{{ tempReservation.reservation.first_name }} {{ tempReservation.reservation.last_name }}</div>
                    <div>{{ tempReservation.reservation.city }}, {{ tempReservation.reservation.state }} {{ tempReservation.reservation.zip }}</div>
                    <div><strong>Email:</strong> {{tempReservation.reservation.email}}</div>
                    <div class="mb-5"><strong>Mobile phone:</strong>  {{tempReservation.reservation.phone}}</div>
                    <v-btn @click="skip">Skip</v-btn>
                    <v-btn ref="confirm-btn" class="ml-2" color="primary"  @click="confirm">Confirm</v-btn>
                </v-col>
            </form>
        </v-row>
    </div>
</template>

<script>
import axios                 from "axios";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";

export default {
    name  : "StepReturnCustomer",
    mixins: [StepperComponentMixin],
    data  : () => ({
        model: {
            full_name: '',
            dob      : null
        },
        tempReservation: null,
        notFoundMessage: '',
        response:{
            full_name:'',

        },
        step: 4,
    }),
    methods:{
        async searchCustomer(){
            if(this.model.full_name!=="" || this.model.dob!==null) {
                const searchResponse = await axios.get('/reservations/search_renter', {
                    params: this.model
                }).catch(error => {
                    return error.response;
                });

                if (searchResponse.data && searchResponse.data.success && searchResponse.data.exists && searchResponse.data.redirect) {
                    const response = await axios.get('/reservations/vue/load_reservation');
                    this.tempReservation = response.data.data;
                    this.$store.commit('set_return_customer_full_name', this.model.full_name);
                    this.$store.commit('set_return_customer_dob', this.model.dob);
                    this.notFoundMessage = '';

                    this.$nextTick(() => {
                        this.$refs['confirm-btn'].$el.focus();
                    })

                } else {
                    this.notFoundMessage = searchResponse.data.message;
                }
            }else{
                this.notFoundMessage = "Name and DOB are required";
            }
        },
        async skip(){
            await axios.post('/reservations/vue/reset_reservation');
            if((((this.$store.state.resources.config.module_type_enabled && this.$store.state.resources.config.module_type != 'module_9')) && !this.$store.state.model.reservation.is_seasonal) || this.$store.state.model.reservation.is_seasonal) {
                this.step = 4;
            }
            if(window.location.href.includes('seasonal')){
                this.step = 2;
            }
            await this.moveToStep(this.step);
        },
        async confirm(){
            this.tempReservation.reservation.date_pickup=null;
            this.tempReservation.reservation.date_return=null;
            this.tempReservation.reservation.is_international_customer = false;
            this.tempReservation.reservation.reservees_number =  this.tempReservation.reservees.length || 1;
            this.tempReservation.reservation.email_confirmation = this.tempReservation.reservation.email;
            for(let key in this.tempReservation.reservation){
                if (!this.$store.state.model.reservation.is_seasonal || (this.$store.state.model.reservation.is_seasonal && (key !== 'date_pickup' && key !== 'date_return'))) {
                    this.$store.commit('set_model_value',{
                        path:'model.reservation.'+key,
                        value:this.tempReservation.reservation[key]
                    })
                }

            }
            this.$store.commit('set_model_value',{path:'model.reservees',value:this.tempReservation.reservees})
            if(((((this.$store.state.resources.config.module_type_enabled && this.$store.state.resources.config.module_type != 'module_9')) &&( (!this.$store.state.resources.config.module_type_enabled) || (this.$store.state.resources.config.module_type_enabled && this.$store.state.resources.config.module_type!=='module_6'))) && !this.$store.state.model.reservation.is_seasonal) || this.$store.state.model.reservation.is_seasonal){
                this.step = 3;
            }
            if(window.location.href.includes('seasonal')){
                this.step = 2;
            }
            await this.moveToStep(this.step);
        },
    },

}
</script>

<style scoped>

</style>
